export default __webpack_public_path__ + "static/blockchain-ba94fd2f9a012a27bf159011ba43b681.svg";